import React, { useState, useContext, useEffect } from 'react'
import '../Dashboard/Dashboard.css'
import * as Yup from 'yup'
import {
    mapData,
    dateFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import Layout from '@/product/components/templates/Layout'
import ReportComponent from '@/views/Report/ReportComponents'
import SettingContext from '@/product/context/setting/settingContext'

const ReportManagement = () => {
    const [state, setState] = useState({})
    const settingcontext = useContext(SettingContext)

    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const additionalfieldUpdate = (payload) => {
        setState(payload)
    }
    const [tableBody, setTableBody] = useState([])
    const [isSelected, setIsSelected] = useState(true)
    const [isLoading, setIsLoading] = useState(false)

    const allSearchOptions = [
        { id: 'within', description: 'Within' },
        { id: 'customSelection', description: 'Custom Selection' },
    ]

    const handleDynamicSelect = (id, field) => {
        setTableBody([])
        if (field === 'closed_auction_completion_report') {
            setIsSelected(false)
            setIsLoading(true)

            let initialValues = {
                page: 1,
                limit: 1000,
                order: 'asc',
                orderby: 'df.show_order',
                primaryTable: 'dynamic_fields',
                filters: {
                    label: { value: '', type: 'like', field: 'df.label' },
                    view_page: { value: '', type: 'in', field: 'df.view_page' },
                    active: { value: 1, type: 'in', field: 'df.active' },
                },
            }
            searchTableFetch(initialValues, field)
        } else {
            setIsSelected(true)
        }
    }

    const parseDate = (value) => {
        if (!value) return null // allow empty
        const [mm, dd, yyyy] = value.split('-') // your current input: MM-DD-YYYY
        return new Date(yyyy, mm - 1, dd) // local date, Safari-safe
    }

    const validation = Yup.object({
        order: Yup.string().required('Required!'),
        action: Yup.string().required('Required!'),
        report: Yup.string().required('Required!'),
        search: Yup.string().required('Required!'),

        start_date: Yup.date()
            .transform((_, original) => parseDate(original))
            .nullable(),

        end_date: Yup.date()
            .transform((_, original) => parseDate(original))
            .nullable()
            .min(Yup.ref('start_date'), 'Should be greater than from date'),

        template_name: Yup.string().when(['template'], {
            is: true,
            then: Yup.string().required('Required'),
        }),
    })

    const dynamicFieldAdd = (item, field) => {
        let fieldSeprate = item.map((el) => {
            {
                if (el?.view_page == 1) {
                    el.field = 'projects_' + el.name
                } else if (el?.view_page == 2) {
                    el.field = el.name
                } else {
                    el.field = 'users_' + el.name
                }

                el.group = [field]
                return el
            }
        })
        let userFiled = fieldSeprate.filter(
            (el) =>
                el.view_page == 3 &&
                el.name !== 'password' &&
                el.name !== 'confirm_password' &&
                el.name !== 'avatar' &&
                el.name !== 'uploadimages'
        )
        let projectField = fieldSeprate.filter(
            (el) =>
                el.view_page == 1 &&
                el.name !== 'password' &&
                el.name !== 'confirm_password' &&
                el.name !== 'avatar' &&
                el.name !== 'uploadimages'
        )
        let AuctionsField = fieldSeprate.filter(
            (el) =>
                el.view_page == 2 &&
                el.name !== 'password' &&
                el.name !== 'confirm_password' &&
                el.name !== 'avatar' &&
                el.name !== 'uploadimages'
        )

        return [
            {
                title: 'User Field',
                formFields: [
                    {
                        id: 19,
                        view_page: '1',
                        label: 'ID',
                        type: 'text',
                        field: 'users_id',
                        sort: 1,
                        sort_field: 'id',
                        show_order: 0,
                        table_search: 0,
                        folder: null,
                        is_deletable: 0,
                        active: 1,
                        filter_type: 'select type',
                        is_default: 0,
                        class: null,
                        diff_name: 0,
                        diff_sort: 0,
                    },
                    ,
                    ...userFiled,
                ],
            },
            {
                title: 'Project Field',
                formFields: [
                    {
                        id: 19,
                        view_page: '1',
                        label: 'ID',
                        type: 'text',
                        field: 'Projects_id',
                        sort: 1,
                        sort_field: 'p.id',
                        show_order: 0,
                        table_search: 0,
                        folder: null,
                        is_deletable: 0,
                        active: 1,
                        filter_type: 'select type',
                        is_default: 0,
                        class: null,
                        diff_name: 0,
                        diff_sort: 0,
                    },
                    ,
                    ...projectField,
                ],
            },
            {
                title: 'Auctions Field',
                formFields: [
                    {
                        id: 19,
                        view_page: '1',
                        label: 'ID',
                        type: 'text',
                        field: 'id',
                        sort: 1,
                        sort_field: 'ac.id',
                        show_order: 0,
                        table_search: 0,
                        folder: null,
                        is_deletable: 0,
                        active: 1,
                        filter_type: 'select type',
                        is_default: 0,
                        class: null,
                        diff_name: 0,
                        diff_sort: 0,
                    },
                    ,
                    ...AuctionsField,
                ],
            },
        ]
    }

    useEffect(() => {
        if (search_fetch_data) {
            let field = search_fetch_data.from
            let dynamicuData = search_fetch_data.records
                ? search_fetch_data.records
                : []
            // .length
            //     ? search_fetch_data.records.filter(
            //           (inner) => inner.active === 1
            //       )
            //     : []
            setTableBody(dynamicFieldAdd(dynamicuData, field))

            setIsLoading(false)
        }
    }, [search_fetch_data])

    const initialValues = {
        action: 'display',
        order: 'asc',
        orderby: '',
        search: 'within',
        report: 'active_user_management',
        within: 'day',
        page: 1,
        limit: 20,
        start_date: dateFormatFunction(new Date()),
        end_date: dateFormatFunction(new Date()),
        limit_results: '',
        searchterm: '',
        fields: [],
        report_heading: '',
        export_file_name: '',
        filters: {
            auctionid: { value: '', type: 'in', field: 'ac.id' },
            userid: { value: '', type: 'in', field: 'u.id' },
            projectsid: { value: '', type: 'in', field: 'u.id' },
            buyer: { value: 0, type: 'like', field: 'bu.username,bu.id' },
            seller: { value: 0, type: 'like', field: 'e.username,e.id' },
            transaction: { value: 0, type: 'in', field: 'pr.trans_id' },
            product: { value: 0, type: 'in', field: 'p.id' },
        },
    }

    const searchInfo = {
        data: [
            {
                label: 'Search Term',
                placeholder: 'Enter Search Term',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
            },
        ],
    }

    const auctionFilter = {
        data: [
            {
                label: 'User ID',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'number',
                filter: true,
                name: 'userid',
                field: 'u.id',
                id: 1,
            },
            {
                label: 'Projects ID',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'number',
                filter: true,
                name: 'projectsid',
                field: 'p.id',
                id: 2,
            },
            {
                label: 'Auction ID',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'number',
                filter: true,
                name: 'auctionid',
                field: 'ac.id',
                id: 3,
            },
        ],
    }

    const report = {
        data: [
            {
                label: 'Report',
                placeholder: 'Enter Report',
                class: 'col-12',
                type: 'select',

                groupoptions: [
                    {
                        head: 'BondRobert Reports',
                        options: [
                            {
                                value: 'live_bids_auctions',
                                show: 'Live Auctions and Bids',
                            },
                            {
                                value: 'all_item_with_bids',
                                show: 'All Items with Number of Bids',
                            },
                            {
                                value: 'transaction_reconcile',
                                show: 'Transaction Reconciliation',
                            },
                        ],
                    },
                    {
                        head: 'User management',
                        options: [
                            { value: 'active_user_management', show: 'Active' },
                            {
                                value: 'deactivate_user_management',
                                show: 'Deactive',
                            },
                            {
                                value: 'unverified_user_management',
                                show: 'Unverified',
                            },
                        ],
                    },
                    {
                        head: 'Product management',
                        options: [
                            { value: 'open_product_management', show: 'Open' },
                            {
                                value: 'ending_product_management',
                                show: 'Ending',
                            },
                            {
                                value: 'closed_product_management',
                                show: 'Closed',
                            },
                            { value: 'sold_product_management', show: 'Sold' },
                        ],
                    },
                    // {
                    //     head: 'Auction management',
                    //     options: [
                    //         { value: 'open_auction_management', show: 'Open' },
                    //         {
                    //             value: 'ending_auction_management',
                    //             show: 'Ending',
                    //         },
                    //         {
                    //             value: 'closed_auction_management',
                    //             show: 'Closed',
                    //         },
                    //         { value: 'sold_auction_management', show: 'Sold' },
                    //     ],
                    // },
                    {
                        head: 'Sold Order management',
                        options: [{ value: 'sold_order', show: 'Sold' }],
                    },
                    {
                        head: 'Invoice management',
                        options: [
                            { value: 'paid_invoice_management', show: 'Paid' },
                            {
                                value: 'unpaid_invoice_management',
                                show: 'Unpaid',
                            },
                        ],
                    },
                    {
                        head: 'Employee management',
                        options: [
                            {
                                value: 'employee_list',
                                show: 'Employee Details',
                            },
                        ],
                    },
                    {
                        head: 'Wallet management',
                        options: [
                            {
                                value: 'deposit_balance',
                                show: 'Wallet Details',
                            },
                        ],
                    },
                    {
                        head: 'Transaction management',
                        options: [
                            {
                                value: 'transaction_list',
                                show: 'Transaction Details',
                            },
                        ],
                    },
                    {
                        head: 'all Paid Product Report',
                        options: [
                            {
                                value: 'all_paid_reports',
                                show: 'All Paid Product Details',
                            },
                        ],
                    },
                    {
                        head: 'All dynamic fields ',
                        options: [
                            {
                                value: 'closed_auction_completion_report',
                                show: 'Auctions',
                            },
                        ],
                    },
                ],
                name: 'report',
            },
        ],
    }

    const limitResult = {
        data: [
            {
                label: 'Limit results',
                placeholder: 'Enter Limit results',
                type: 'number',
                class: 'col-12 ',
                size: 'small',
                name: 'limit_results',
            },
        ],
    }

    let fieldsToShow = []

    fieldsToShow = [
        {
            field: 'common_invoice',
            label: 'Invoice ID',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'trans_id',
            label: 'Transaction ID',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'buyerid',
            label: 'Buyer ID',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'buyer_name',
            label: 'Buyer',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'project_id',
            label: 'Product ID',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'title',
            label: 'Product Name',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'market_status',
            label: 'Product Status',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'date_added',
            label: 'Product Date Added',
            sort: true,
            type: 'datetime',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'date_closed',
            label: 'Product Date Closed',
            sort: true,
            type: 'datetime',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'posted_by',
            label: 'Posted By',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'wprice',
            label: 'Product Won Price',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'box_code',
            label: 'Product Box Code',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'storage_location',
            label: 'Box Location',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'serial_number',
            label: 'Product Serial Number',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'desc_proc',
            label: 'Product Comments',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'sprice',
            label: 'Product Start Price',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'rprice',
            label: 'Product Reserve Price',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'bprice',
            label: 'Buy It Now Price',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'sold',
            label: 'Sold',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'admin_fee_update',
            label: 'Updated Post Sale Fee',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'transaction_status',
            label: 'Transaction Status',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
            test: 1,
        },
        {
            field: 'buyer_amount_total_inc_PSH_fee_USD',
            label: 'Buyer Amount Total Inc PSH Fee USD',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
            test: 1,
        },
        {
            field: 'seller_name',
            label: 'Seller',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            test: 1,
            field: 'commission_buyer_usd',
            label: 'Commission Buyer USD',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'commission_seller_usd',
            label: 'Commission Seller USD',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'commission_total_usd',
            label: 'Commission Total USD',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'admin_fee',
            label: 'Post Sale Handling Fee USD',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'seller_amount_total_inc_psh_fee_usd',
            label: 'Seller Amount Total Inc PSH Fee USD',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'card_fee_usd',
            label: 'Card Fee USD',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'currency',
            label: 'Currency',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'exchange_rate',
            label: 'Daily Conversion Rate',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_status',
            label: 'Payment Status',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_amount',
            label: 'Payment Amount',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_settlement_amount',
            label: 'Payment Settlement Amount',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_currency',
            label: 'Payment Currency',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_product',
            label: 'Payment Product',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_created_date',
            label: 'Payment Created Date',
            sort: true,
            type: 'datetime',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_created_time',
            label: 'Payment Created Time',
            sort: true,
            type: 'datetime',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_processed_date',
            label: 'Payment Processed Date',
            sort: true,
            type: 'datetime',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_processed_time',
            label: 'Payment Processed Time',
            sort: true,
            type: 'datetime',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_settled_date',
            label: 'Payment Settled Date',
            sort: true,
            type: 'datetime',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_account_card_name',
            label: 'Payment Account Card Name',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_account_card_type',
            label: 'Payment Account Card Type',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_customer_city',
            label: 'Payment Customer City',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_customer_address',
            label: 'Payment Customer Address',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_customer_name',
            label: 'Payment Customer Name',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_customer_zip',
            label: 'Payment Customer Postcode',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_customer_state',
            label: 'Payment Customer State',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_customer_phone',
            label: 'Payment Customer Phone',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_customer_email',
            label: 'Payment Customer Email',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_fee',
            label: 'Payment Fee',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_provider_reference',
            label: 'Payment Provider Reference',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_provider_response',
            label: 'Payment Provider Response',
            sort: true,
            type: '',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'total_amount_usd',
            label: 'Total Amount USD',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'total_amount_cur',
            label: 'Total Amount CUR',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'total_commission_amount_usd',
            label: 'Total Commission Amount USD',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'total_commission_amount_cur',
            label: 'Total Commission Amount CUR',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'seller_amount_usd',
            label: 'Seller Amount USD',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'seller_amount_cur',
            label: 'Seller Amount CUR',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_settlement_amount_cur',
            label: 'Payment Settlement Amount CUR',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'payment_due_to_seller_cur',
            label: 'Payment Due To Seller CUR',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'remitted_date',
            label: 'Remitted Date',
            sort: true,
            type: 'datetime',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'funds_remitted',
            label: 'Funds Remitted',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'buyer_amount_cur',
            label: 'Buyer Amount CUR',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'remittance_processing_fee',
            label: 'Remittance Processing Fee',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'rpf_cur',
            label: 'RPF CUR',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'funds_remitted_cur',
            label: 'Funds Remitted CUR',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'funds_due_to_seller_cur',
            label: 'Funds Due To Seller CUR',
            sort: true,
            type: 'price',
            group: [
                'transaction_reconcile',
                'transaction_reconcile_transaction_reconciliation',
            ],
        },
        {
            field: 'id',
            label: 'User ID',
            sort: true,
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'user_fullname',
            label: 'User Name',
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'email',
            label: 'User Email',
            sort: true,
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'phone',
            label: 'Phone Number',
            type: '',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'created_at',
            label: 'Created Date',
            sort: true,
            type: 'datetime',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
            ],
        },
        {
            field: 'last_login',
            label: 'Last Login',
            sort: true,
            type: 'datetime',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
            ],
        },
        {
            field: 'status',
            label: 'Status',
            type: 'capitalize',
            group: [
                'active_user_management',
                'deactivate_user_management',
                'unverified_user_management',
                'deposit_balance',
            ],
        },
        {
            field: 'deposit_amount',
            label: 'Wallet Balance',
            type: 'price',
            group: ['deposit_balance'],
        },

        {
            field: 'id',
            label: 'Product ID',
            sort: true,
            type: '',
            group: [
                'open_product_management',
                'live_bids_auctions',

                'all_item_with_bids',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
            ],
        },

        {
            field: 'title',
            label: 'Product Name',
            sort: true,
            type: '',
            group: [
                'open_product_management',

                'all_item_with_bids',
                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
            ],
        },

        {
            field: 'brand',
            label: 'Marca',
            sort: true,
            type: '',
            group: ['live_bids_auctions'],
        },
        {
            field: 'year',
            label: 'Product Year',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },
        {
            field: 'qty',
            label: 'Quantity',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },
        {
            field: 'date_added',
            label: 'Starting Date',
            sort: true,
            type: 'datetime',
            group: [
                'open_product_management',
                'live_bids_auctions',

                'ending_product_management',
                'closed_product_management',
                'all_item_with_bids',
                'sold_product_management',
                'all_paid_reports',
            ],
        },
        {
            field: 'date_closed',
            label: 'End Date',
            sort: true,
            type: 'datetime',
            group: [
                'open_product_management',
                'live_bids_auctions',
                'ending_product_management',

                'all_item_with_bids',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
            ],
        },

        {
            field: 'sellerid',
            label: 'Seller ID',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },
        {
            field: 'seller_name',
            label: 'Seller Username',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },
        {
            field: 'auction_type',
            label: 'Product Type',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },
        {
            field: 'market_status',
            label: 'Product Status',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },
        {
            field: 'sprice',
            label: 'Start Price',
            sort: true,
            type: 'price',
            group: ['all_item_with_bids'],
        },
        {
            field: 'bprice',
            label: 'Buy it Now Price',
            sort: true,
            type: 'price',
            group: ['all_item_with_bids'],
        },
        {
            field: 'rprice',
            label: 'Reserve Prices',
            sort: true,
            type: 'price',
            group: ['all_item_with_bids'],
        },
        {
            field: 'sale_price',
            label: 'Sale Price',
            sort: true,
            type: 'price',
            group: ['all_item_with_bids'],
        },
        {
            field: 'admin_fee',
            label: 'Post Sale Handling Amount',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },
        {
            field: 'number_bids',
            label: 'Number of Bids',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },

        // {
        //     field: 'final_bid_date',
        //     label: 'Final Bid Date',
        //     sort: true,
        //     type: 'datetime',
        //     group: ['all_item_with_bids'],
        // },
        {
            field: 'wprice',
            label: 'Maximum Max Bid Price',
            sort: true,
            type: 'price',
            group: ['all_item_with_bids'],
        },
        {
            field: 'max_bids_userid',
            label: 'Highest Bidder User ID',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },

        {
            field: 'max_bids_username',
            label: 'Highest Bidder UserName',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },
        {
            field: 'buyerid',
            label: 'High Bidder User ID',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },
        {
            field: 'buyer_name',
            label: 'Buyer Username',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },
        {
            field: 'type_release',
            label: 'Type Release',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },
        {
            field: 'special_release_name',
            label: 'Special Release Name',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },
        {
            field: 'listing_type',
            label: 'Listing Type',
            sort: true,
            type: 'customOptions',
            table: {
                options: [
                    { id: 354, description: 'Single Item Listing' },
                    { id: 355, description: 'Multi Item Listing' },
                    { id: 356, description: 'Partial Box Listing' },
                ],
                showField: 'description',
                valueField: 'id',
            },
            group: ['all_item_with_bids'],
        },
        {
            field: 'number_of_cigars_remaining',
            label: 'Current number of cigar in Box',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },
        {
            field: 'current_number_of_cigars_in_box',
            label: 'Original number of cigar in Box',
            sort: true,
            type: '',
            group: ['all_item_with_bids'],
        },

        {
            field: 'vitola',
            label: 'Vitola de Salida',
            sort: true,
            type: '',
            group: ['live_bids_auctions'],
        },
        {
            field: 'packaging',
            label: 'Packaging',
            sort: true,
            type: '',
            group: ['live_bids_auctions'],
        },
        {
            label: 'No. of Cigars',
            field: 'current_number_of_cigars_in_box',
            sort: true,
            type: '',
            group: ['live_bids_auctions'],
        },
        {
            field: 'partialbox',
            label: 'Partial Box',
            sort: true,
            type: '',
            group: ['live_bids_auctions'],
        },
        {
            field: 'number_of_cigars_remaining',
            label: 'Cigars Remaining',
            sort: true,
            type: '',
            group: ['live_bids_auctions'],
        },
        {
            field: 'username',
            label: 'Seller Username',
            sort: true,
            type: '',
            group: ['live_bids_auctions'],
        },
        {
            field: 'country',
            label: 'Seller country',
            sort: true,
            type: '',
            group: ['live_bids_auctions'],
        },
        {
            field: 'bids_cnt',
            label: 'No. of Bids',
            sort: true,
            type: '',
            group: ['live_bids_auctions'],
        },
        {
            field: 'rprice',
            label: 'Reserve Price',
            sort: true,
            type: 'price',
            group: ['live_bids_auctions'],
        },
        {
            field: 'reserve_bid_status',
            label: 'Reserve Met',
            sort: true,
            type: '',
            group: ['live_bids_auctions'],
        },
        {
            field: 'wprice',
            label: 'Current High Bid',
            sort: true,
            type: 'price',
            group: ['live_bids_auctions'],
        },
        {
            field: 'high_username',
            label: 'Highest Bidder UserName',
            sort: true,
            type: '',
            group: ['live_bids_auctions'],
        },
        {
            field: 'max_price',
            label: 'Maximum Max Bid Price',
            sort: true,
            type: 'price',
            group: ['live_bids_auctions'],
        },

        {
            field: 'bprice',
            label: 'Buy it Now Price',
            sort: true,
            type: 'price',
            group: ['live_bids_auctions'],
        },

        {
            field: 'lot_id',
            label: 'Lot ID',
            sort: true,
            type: '',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'lot_title',
            label: 'Lot Title',
            sort: true,
            type: 'capitalize',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'lot_date_added',
            label: 'Lot Starting Date',
            sort: true,
            type: 'date',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'lot_date_closed',
            label: 'Lot End Date',
            sort: true,
            type: 'date',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'sprice',
            label: 'Starting Price',
            type: 'price',
            group: [
                'open_product_management',

                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'bprice',
            label: 'Buynow Price',
            type: 'price',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'qty',
            label: 'Total Quantity',
            type: '',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'sold',
            label: 'Sold Quantity',
            type: '',
            group: [
                'open_auction_management',
                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'buynowamount',
            label: 'Sold Price',
            type: 'price',
            group: [
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
            ],
        },
        {
            field: 'wprice',
            label: 'Current Price',
            sort: true,
            type: 'price',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
                'open_auction_management',
                'ending_auction_management',

                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'market_status',
            label: 'Status',
            sort: true,
            type: 'capitalize',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',

                'sold_product_management',

                'all_paid_reports',
                'sold_order',
            ],
        },
        {
            field: 'totalbids',
            label: 'No. of Bids',
            type: '',
            group: [
                'open_product_management',

                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',

                'sold_order',
                'open_auction_management',

                'ending_auction_management',
                'closed_auction_management',
                'sold_auction_management',
            ],
        },
        {
            field: 'numDiffBidders',
            label: 'No. of Different Bidders',
            type: '',
            group: [
                'open_product_management',

                'ending_product_management',
                'closed_product_management',
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
            ],
        },
        {
            field: 'winnerName',
            label: 'Buyer Name',
            type: '',
            group: [
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
            ],
        },
        {
            field: 'winemail',
            label: 'Winner Email',
            type: '',
            group: [
                'open_product_management',
                'ending_product_management',
                'closed_product_management',
            ],
        },
        {
            field: 'winnerEmail',
            label: 'Winner Email',
            type: 'capitalize',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'winnerCompany',
            label: 'Buyer Company',
            type: 'capitalize',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'buynowemail',
            label: 'Buyer Email',
            type: '',
            group: [
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
            ],
        },
        {
            field: 'common_invoice',
            label: 'Invoice ID',
            sort: true,
            type: '',
            group: [
                'sold_product_management',
                'all_paid_reports',
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
                'transaction_list',
            ],
        },
        {
            field: 'paid_date',
            label: 'Paid Date',
            sort: true,
            type: 'datetime',
            group: ['sold_product_management', 'all_paid_reports'],
        },
        {
            field: 'shipping_amount',
            label: 'Shipping Price',
            sort: true,
            type: 'price',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'total_invoice',
            label: 'Total Price',
            sort: true,
            type: 'price',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'date_added',
            label: 'Sold Date',
            sort: true,
            type: 'date',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'paid_date',
            label: 'Paid Date',
            sort: true,
            type: 'date',
            group: ['paid_invoice_management', 'unpaid_invoice_management'],
        },
        {
            field: 'project_id',
            label: 'Product ID',
            sort: true,
            type: '',
            group: ['sold_order'],
        },
        {
            field: 'sold_qty',
            label: 'Purchased Qty',
            sort: true,
            type: '',
            group: [
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
            ],
        },
        {
            field: 'date_added',
            label: 'Sale Date',
            sort: true,
            type: 'date',
            group: ['sold_order'],
        },
        {
            field: 'paid',
            label: 'Paid Status',
            sort: true,
            type: 'paid_status',
            group: [
                'sold_order',
                'paid_invoice_management',
                'unpaid_invoice_management',
            ],
        },
        {
            field: 'emp_firstname',
            label: 'First Name',
            sort: true,
            type: 'capitalize',
            group: ['employee_list'],
        },
        {
            field: 'emp_lastname',
            label: 'Last Name',
            sort: true,
            type: 'capitalize',
            group: ['employee_list'],
        },
        {
            field: 'emp_email',
            label: 'Email',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_phone',
            label: 'Phone Number',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_address1',
            label: 'Address',
            sort: true,
            type: 'capitalize',
            group: ['employee_list'],
        },
        {
            field: 'emp_city',
            label: 'City',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_zip',
            label: 'Zip Code',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_state',
            label: 'State',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_country',
            label: 'Country',
            sort: true,
            type: '',
            group: ['employee_list'],
        },
        {
            field: 'emp_type',
            label: 'Employee Type',
            sort: true,
            type: 'em_type',
            group: ['employee_list'],
        },
        {
            field: 'trans_id',
            label: 'Transaction ID',
            sort: true,
            type: '',
            group: ['transaction_list'],
        },
        {
            field: 'amount',
            label: 'Amount',
            sort: true,
            type: 'price',
            group: ['transaction_list'],
        },
        {
            field: 'user_fullname',
            label: 'Buyer Name',
            sort: true,
            type: 'capitalize',
            group: ['transaction_list'],
        },
        {
            field: 'email',
            label: 'Buyer Email',
            sort: true,
            type: '',
            group: ['transaction_list'],
        },
        {
            field: 'payment_method',
            label: 'Payment Type',
            sort: true,
            type: 'capitalize',
            group: ['transaction_list'],
        },
        {
            field: 'card_type',
            label: 'Gateway',
            sort: true,
            type: 'capitalize',
            group: ['transaction_list'],
        },
        {
            field: 'created_at',
            label: 'Paid Date',
            sort: true,
            type: 'datetime',
            group: ['transaction_list'],
        },
        {
            field: 'totalbids',
            label: 'No. of Bids',
            type: '',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_deposit_amount',
            label: 'Bid Deposit Amount',
            sort: true,
            type: '',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_deposit_status',
            label: 'Bid Deposit Status',
            sort: true,
            type: '',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_deposit_date_added',
            label: 'Bid Deposit Date Added',
            sort: true,
            type: 'datetime',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_deposit_gateway',
            label: 'Bid Deposit Gate Way',
            sort: true,
            type: '',
            group: ['all_paid_reports'],
        },
        {
            field: 'bid_refunded',
            label: 'Bid refended',
            sort: true,
            type: '',
            group: ['all_paid_reports'],
        },
    ]

    return (
        <Layout>
            <ReportComponent
                orderSort={global?.orderSort ? global.orderSort : false}
                formFields={isSelected ? fieldsToShow : tableBody}
                dropDownFields={[
                    {
                        field: 'listing_type',
                        label: 'Listing Type',
                        sort: true,
                        type: 'customOptions',
                        table: {
                            options: [
                                { id: 354, description: 'Single Item Listing' },
                                { id: 355, description: 'Multi Item Listing' },
                                { id: 356, description: 'Partial Box Listing' },
                            ],
                            showField: 'description',
                            valueField: 'id',
                        },
                        group: ['all_item_with_bids'],
                    },
                ]}
                loading={isLoading}
                customField={'all_item_with_bids'}
                report={report}
                allSearchOptions={allSearchOptions}
                validationSchema={validation}
                limitResult={limitResult}
                dynamicSelect={handleDynamicSelect}
                initialValues={initialValues}
                additionalfieldUpdate={additionalfieldUpdate}
                searchInfo={searchInfo}
                auctionFilter={auctionFilter}
                customLabel="Customize your report using a wide variety of date range options."
                SubmitBtnLabel="Generate Report"
            />
            {/* <ReportComponent
                orderSort={global?.orderSort ? global.orderSort : false}
                formFields={isSelected ? fieldsToShow : tableBody}
                loading={isLoading}
                report={report}
                allSearchOptions={allSearchOptions}
                validationSchema={validation}
                limitResult={limitResult}
                initialValues={initialValues}
                dynamicSelect={handleDynamicSelect}
                additionalfieldUpdate={additionalfieldUpdate}
                searchInfo={searchInfo}
                customLabel="Customize your report using a wide variety of date range options."
                SubmitBtnLabel="Generate Report"
            /> */}
        </Layout>
    )
}

export default ReportManagement
